import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { backofficePath } from "./backoffice_path";

export default class extends Controller {
  static targets = ['list'];
  static values = {
    inputSelector: String,
    childrenSelector: String
  };

  connect() {
    const scope = this;
    this.sortable = Sortable.create(this.listTarget, {
      onSort: () => scope.onSort(scope),
    });
  }

  onSort(scope) {
    const selector = scope.inputSelectorValue;
    const allItems = scope.listTarget.querySelectorAll(scope.childrenSelectorValue);
    const data = {};
    for (let i = 0; i < allItems.length; i++) {
      const item = allItems[i];
      data[item.querySelector(this.inputSelectorValue).dataset.professionalId] = i;
      item.querySelector(selector).value = i;
    }
    fetch(backofficePath(`/professionals/sort`), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ professionals: data }),
    });
  }
}
